<ion-header *ngIf="isModal">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'option.' + option | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-grid *ngIf="!isLoading" fixed>
  <ion-row>
    <ion-col sizeXs="12">
      <ion-grid *ngIf="option === 'automatic'">
        <ion-row>
          <ion-col size="8">
            <p class="ion-padding-vertical">Numero de boletas</p>
          </ion-col>
          <ion-col size="4">
            <app-quantity [max]="100" [quantity]="quantity" (quantityChange)="changeQuantity($event)"></app-quantity>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="isPayment">
    <ion-col size="12" class="logo-container">
      <div *ngIf="gameType === 'tris'">
        <ion-img *ngIf="isMultiplier" [src]="'/assets/logos/tris-multiplicador.svg'"></ion-img>
        <ion-img *ngIf="!isMultiplier" [src]="logoTris"></ion-img>
      </div>

      <div *ngIf="gameType === 'melate'">
        <ion-img *ngIf="isRetro" [src]="logoMelateRetro"></ion-img>
        <ion-img *ngIf="isRevancha" [src]="'/assets/boards/melateRevancha.png'"></ion-img>
        <ion-img *ngIf="isRevanchita" [src]="'/assets/boards/melateRevanchita.png'"></ion-img>
        <ion-img *ngIf="!isRetro && !isRevancha && !isRevanchita" slot="start" [src]="logoMelate"></ion-img>
      </div>

      <div *ngIf="gameType === 'chispazo'">
        <ion-img slot="start" [src]="logoChispazo"></ion-img>
      </div>

      <div *ngIf="gameType === 'progol'">
        <ion-img *ngIf="isMediaSemana" slot="start" [src]="logoProgolMedia"></ion-img>
        <ion-img *ngIf="isRevancha" slot="start" [src]="logoProgolRevancha"></ion-img>
        <ion-img *ngIf="!isMediaSemana && !isRevancha" slot="start" [src]="logoProgol"></ion-img>
      </div>

      <div *ngIf="gameType === 'protouch'">
        <ion-img slot="start" [src]="logoProtouch"></ion-img>
      </div>

      <div *ngIf="gameType === 'gana-gato'">
        <ion-img slot="start" [src]="logoGanaGato"></ion-img>
      </div>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="dates.length">
    <ion-col size="12" class="center-calendar">
      <app-date-list [dates]="dates"></app-date-list>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="!isPayment">
    <ion-col *ngFor="let item of melateTickets; let i = index" [sizeXs]="12">
      <ion-card class="ion-no-margin melate">
        <ion-card-content class="ion-no-padding">
          <ion-grid>
            <ion-row class="ion-no-padding selecteds">
              <ion-fab-button *ngFor="let value of item.value" size="small" [class]="'long-' + item.price.size">
                {{ isCoperacha ? 'X' : value }}
              </ion-fab-button>
            </ion-row>
            <ion-toolbar class="toolbar">
              <ion-img *ngIf="isRetro" slot="start" class="ion-margin-top small" [src]="logoMelateRetro"></ion-img>

              <ion-img
                *ngIf="!isRetro && item.types.includes('Revanchita')"
                slot="start"
                class="ion-margin-top small"
                [src]="'/assets/boards/melateRevanchita.png'"
              ></ion-img>

              <ion-img
                *ngIf="!isRetro && item.types.includes('Revancha') && !item.types.includes('Revanchita')"
                slot="start"
                class="ion-margin-top small"
                [src]="'/assets/boards/melateRevancha.png'"
              ></ion-img>

              <ion-img
                *ngIf="!isRetro && !item.types.includes('Revancha') && !item.types.includes('Revanchita')"
                slot="start"
                class="ion-margin-top small"
                [src]="logoMelate"
              ></ion-img>
              <ion-row>
                <ion-fab-button size="small" [color]="'light'">
                  {{ letras[i] }}
                </ion-fab-button>
                <!-- <p class="center">Sencillo</p> -->
              </ion-row>
              <ion-buttons *ngIf="isModal" slot="end">
                <ion-button (click)="changeSelected(i)" color="primary">
                  <ion-icon
                    slot="icon-only"
                    [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'"
                  ></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="reload(i)" color="secondary">
                  <ion-icon slot="icon-only" name="refresh"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option !== 'coperacha'" (click)="goTo()" color="secondary">
                  <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="deleteValue(i)" color="danger">
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-grid>
        </ion-card-content>
      </ion-card>
    </ion-col>
    <ion-col *ngFor="let item of sorteoTickets; let i = index" size="12">
      <ion-card class="ion-no-margin sorteo">
        <ion-card-content class="ion-no-padding">
          <ion-grid>
            <ng-container *ngFor="let billete of item.billete">
              <ion-row class="ion-no-padding selecteds">
                <ion-fab-button
                  *ngFor="let digito of getDigits(billete.numeroBillete, item.drawType || ''); let j = index"
                  size="small"
                  [class]="item.drawType"
                >
                  {{ digito }}
                </ion-fab-button>
              </ion-row>

              <ion-row *ngIf="item.logos?.iconUrl">
                <div *ngIf="item.drawType === 'zodiaco' || item.drawType === 'zodiaco-especial'">
                  <p class="center">
                    {{ getZodiacName(billete.signo).es }}
                    <ion-icon
                      [src]="'/assets/icons/zodiac/game-icons_' + getZodiacName(billete.signo).en + '.svg'"
                    ></ion-icon>
                  </p>
                </div>
              </ion-row>
            </ng-container>

            <ion-toolbar class="toolbar">
              <ion-img
                slot="start"
                class="ion-margin-top small"
                [src]="item.logos?.iconUrl || 'assets/images/default-icon.svg'"
              ></ion-img>

              <ion-buttons *ngIf="isModal" slot="end">
                <ion-button (click)="changeSelected(i)" color="primary">
                  <ion-icon
                    slot="icon-only"
                    [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'"
                  ></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="reload(i)" color="secondary">
                  <ion-icon slot="icon-only" name="refresh"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option !== 'coperacha'" (click)="goTo()" color="secondary">
                  <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="deleteValue(i)" color="danger">
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-grid>
        </ion-card-content>
      </ion-card>
    </ion-col>
    <ion-col *ngFor="let item of chispazoTickets; let i = index" size="12">
      <ion-card class="ion-no-margin chispazo">
        <ion-card-content class="ion-no-padding">
          <ion-grid>
            <ion-row class="ion-no-padding selecteds">
              <ion-fab-button *ngFor="let value of item.value" size="small" [class]="sorteoType">
                {{ value }}
              </ion-fab-button>
            </ion-row>
            <ion-toolbar class="toolbar">
              <ion-img slot="start" class="ion-margin-top small" [src]="logoChispazo"></ion-img>
              <ion-buttons *ngIf="isModal" slot="end">
                <ion-button (click)="changeSelected(i)" color="primary">
                  <ion-icon
                    slot="icon-only"
                    [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'"
                  ></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="reload(i)" color="secondary">
                  <ion-icon slot="icon-only" name="refresh"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option !== 'coperacha'" (click)="goTo()" color="secondary">
                  <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="deleteValue(i)" color="danger">
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-grid>
        </ion-card-content>
      </ion-card>
    </ion-col>
    <ion-col *ngFor="let item of trisTickets; let i = index" sizeXs="12" [sizeSm]="isModal || isResume ? 12 : 6">
      <ion-card class="ion-no-margin tris">
        <ion-card-content class="ion-no-padding">
          <ion-grid>
            <ion-row class="ion-no-padding selecteds">
              <ion-fab-button *ngFor="let value of item.value" size="small" [class]="sorteoType" [disabled]="value < 0">
                {{ value < 0 ? 'X' : value }}
              </ion-fab-button>
            </ion-row>
            <ion-toolbar class="toolbar">
              <ion-img
                *ngIf="item.multiplicadorAmount"
                slot="start"
                class="ion-margin-top small"
                [src]="'/assets/logos/tris-multiplicador.svg'"
              ></ion-img>
              <ion-img
                *ngIf="!item.multiplicadorAmount"
                slot="start"
                class="ion-margin-top small"
                [src]="logoTris"
              ></ion-img>
              <ion-row *ngIf="item.ticketAmount > 1">
                <ion-col size="12">
                  <p class="ion-text-center">${{ item.ticketAmount }}</p>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col *ngIf="item.multiplicadorAmount > 1" size="6">
                  <p class="ion-text-center">MP {{ item.multiplicadorAmount }}</p>
                </ion-col>
                <ion-col size="6">
                  <p class="ion-text-center">{{ item.price.name }}</p>
                </ion-col>
              </ion-row>
              <ion-buttons *ngIf="isModal" slot="end">
                <ion-button (click)="changeSelected(i)" color="primary">
                  <ion-icon
                    slot="icon-only"
                    [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'"
                  ></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="reload(i)" color="secondary">
                  <ion-icon slot="icon-only" name="refresh"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option !== 'coperacha'" (click)="goTo()" color="secondary">
                  <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="deleteValue(i)" color="danger">
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-grid>
        </ion-card-content>
      </ion-card>
    </ion-col>
    <ion-col
      *ngFor="let item of progolTickets; let i = index"
      [ngClass]="{ hidden: !quinielaValues[i].length }"
      sizeXs="12"
      [sizeSm]="isModal || isResume ? 12 : 6"
    >
      <ion-card class="ion-no-margin progol">
        <ion-card-content class="ion-no-padding">
          <ion-grid>
            <ion-row class="ion-no-padding selecteds">
              <ion-fab-button
                *ngFor="let value of quinielaValues[i]"
                size="small"
                [ngClass]="{
                  'long-7': quinielaValues[i].length >= 6,
                  revancha: quinielaValues[i].length === 7,
                  'media-semana': isMediaSemana,
                  'long-9': isMediaSemana
                }"
              >
                {{ value }}
              </ion-fab-button>
            </ion-row>
            <ion-toolbar class="toolbar">
              <ion-img
                slot="start"
                class="ion-margin-top small"
                [src]="
                  isMediaSemana ? logoProgolMedia : quinielaValues[i].length === 7 ? logoProgolRevancha : logoProgol
                "
              ></ion-img>
              <ion-row *ngIf="quinielaValues[i].length === 7">
                <ion-col size="12">
                  <p class="">Revancha</p>
                </ion-col>
              </ion-row>
              <ion-row> </ion-row>
              <ion-buttons *ngIf="isModal" slot="end">
                <ion-button (click)="changeSelected(i)" color="primary">
                  <ion-icon
                    slot="icon-only"
                    [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'"
                  ></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="reload(i)" color="secondary">
                  <ion-icon slot="icon-only" name="refresh"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option !== 'coperacha'" (click)="goTo()" color="secondary">
                  <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="deleteValue(i)" color="danger">
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-grid>
        </ion-card-content>
      </ion-card>
    </ion-col>
    <ion-col
      *ngFor="let item of protouchTickets; let i = index"
      [ngClass]="{ hidden: !quinielaValues[i].length }"
      sizeXs="12"
      [sizeSm]="isModal || isResume ? 12 : 6"
    >
      <ion-card class="ion-no-margin protouch">
        <ion-card-content class="ion-no-padding">
          <ion-grid>
            <ion-row class="ion-no-padding selecteds">
              <ion-fab-button
                *ngFor="let value of quinielaValues[i]; let j = index"
                size="small"
                [ngClass]="{ 'long-7': quinielaValues[i].length >= 6, touch: j === 13 }"
              >
                {{ value }}
              </ion-fab-button>
            </ion-row>
            <ion-toolbar class="toolbar">
              <ion-img slot="start" class="ion-margin-top small" [src]="logoProtouch"></ion-img>
              <!-- <ion-row *ngIf="item.ticketAmount > 1">
                <ion-col size="12">
                  <p class="ion-text-center">${{ item.ticketAmount }}</p>
                </ion-col>
              </ion-row> -->
              <ion-row> </ion-row>
              <ion-buttons *ngIf="isModal" slot="end">
                <ion-button (click)="changeSelected(i)" color="primary">
                  <ion-icon
                    slot="icon-only"
                    [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'"
                  ></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="reload(i)" color="secondary">
                  <ion-icon slot="icon-only" name="refresh"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option !== 'coperacha'" (click)="goTo()" color="secondary">
                  <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="deleteValue(i)" color="danger">
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-grid>
        </ion-card-content>
      </ion-card>
    </ion-col>
    <ion-col
      *ngFor="let item of ganaGatoTickets; let i = index"
      [sizeXs]="isModal || isResume ? 12 : 6"
      [sizeSm]="isModal || isResume ? 12 : 4"
    >
      <ion-card class="ion-no-margin gana-gato">
        <ion-card-content class="ion-no-padding">
          <ion-grid>
            <!-- <ion-row class="ion-no-padding selecteds">
              <ion-fab-button *ngFor="let value of item.value" size="small" [class]="sorteoType">
                {{ value }}
              </ion-fab-button>
            </ion-row> -->
            <ion-row class="ion-no-padding selecteds">
              <ion-fab-button *ngFor="let value of item.value | slice : 0 : 3" size="small" [class]="sorteoType">
                {{ value }}
              </ion-fab-button>
            </ion-row>
            <ion-row class="ion-no-padding selecteds">
              <ion-fab-button *ngFor="let v of [3, 0, 4]" size="small" [class]="sorteoType" [disabled]="!v">
                {{ v ? item.value[v] : '$' }}
              </ion-fab-button>
            </ion-row>
            <ion-row class="ion-no-padding selecteds">
              <ion-fab-button *ngFor="let value of item.value | slice : 5" size="small" [class]="sorteoType">
                {{ value }}
              </ion-fab-button>
            </ion-row>
            <ion-toolbar class="toolbar">
              <ion-img slot="start" class="ion-margin-top small" [src]="logoGanaGato"></ion-img>
              <ion-buttons *ngIf="isModal" slot="end">
                <ion-button (click)="changeSelected(i)" color="primary">
                  <ion-icon
                    slot="icon-only"
                    [name]="selected[i] ? 'checkmark-circle-outline' : 'ellipse-outline'"
                  ></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="reload(i)" color="secondary">
                  <ion-icon slot="icon-only" name="refresh"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option !== 'coperacha'" (click)="goTo()" color="secondary">
                  <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                </ion-button>
                <ion-button *ngIf="option === 'automatic'" (click)="deleteValue(i)" color="danger">
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-grid>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
